import { get } from 'lodash';
import { useTranslation } from 'react-i18next';

import { FormField, IAutocompleteProps } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { CorporateUserStatus } from 'corporate/enums';
import { corporateUserService } from 'corporate/services';

interface IProps extends IAutocompleteProps {
  name: string;
  label?: string;
}

export const CorporateUserFormField = ({
  name = 'corporateUser',
  label,
  requestPayload,
  ...rest
}: IProps) => {
  const { t } = useTranslation();

  const { control, errors } = useFormContext();

  return (
    <FormField
      name={name}
      type={InputType.AUTOCOMPLETE}
      inputProps={{
        label: label ?? t('labelUser'),
        placeholder: t('placeholderSelectUser'),
        control,
        error: get(errors, name),
        getOptions: corporateUserService.getCorporateUsersAutocomplete,
        requestPayload: {
          ...requestPayload,
          filters: {
            ...requestPayload?.filters,
            status: `"${CorporateUserStatus.ACTIVE}"`,
          },
        },
        ...rest,
      }}
    />
  );
};
